<template>
  <div class="campaign">
    <template v-if="!isLoading && !loadingData">
      <div class="campaign__back" @click.stop="goToAllCampaign()">
        <span class="campaign__back__icon"><i class="adx-ic_chevron_left"></i></span>
        <span class="campaign__back__all">All Campaign</span>
      </div>
      <div class="campaign__title">
        <h1 class="medium-title">{{ campaign.title }}</h1>
      </div>
      <div class="campaign__period">
        <span class="subhead period-text">Period of campaign</span>
        <span class="subhead">{{ displayPeriod(campaign.start, campaign.end) }}</span>
      </div>
      <div class="campaign__status">
        <span class="subhead status-text">Status</span>
        <span class="subhead">{{ displayStatus(campaign.status) }}</span>
      </div>
      <div class="campaign__search" @click.stop="focusSearch()">
        <span class="icon"><i class="adx-ic_search"></i></span>
        <input 
          ref="inputSearch"
          v-model="searchText" 
          type="text" class="input-search" 
          placeholder="Search location">
      </div>
      <table class="table-device">
        <thead>
          <th>Location</th>
          <th>Placement</th>
          <th>Actual Play</th>
          <th>Min Played</th>
        </thead>
        <tbody>
          <tr v-if="campaign.devices.length == 0">
            <td colspan="6">
              <adx-empty />
            </td>
          </tr>
          <tr v-else-if="campaign.devices.length > 0" v-for="device in campaign.devices" :key="device.id">
            <td class="location">{{ device.location }}</td>
            <td>{{ device.placement }}</td>
            <td>{{ device.actual_play }}</td>
            <td>{{ device.min_count }}</td>
          </tr>
        </tbody>
      </table>
      <div class="campaign__footer">
        <adx-pagination 
          @change-page="selectPage" 
          :maxPage="maxPage" 
          :selectedPage="selectedPage" />
      </div>
    </template>
    <div v-else class="campaign__loading">
      <adx-loading />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Empty from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { helpers } from '@/lib/validation/'

export default {
  name: 'adx-dashboard-campaign-detail',
  components: {
    'adx-pagination': Pagination,
    'adx-empty': Empty,
    'adx-loading': Loading,
  },
  props: {

  },
  data() {
    return {
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      campaignId: null,
      campaign: {
        title: '',
        start: '',
        end: '',
        status: '',
        devices: []
      },
      isLoading: false,
      loadingData: false,
    }
  },
  computed: {

  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getCampaignDetail()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.campaignId = this.$route.params.id
    this.isLoading = true
    this.getCampaignDetail()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    focusSearch() {
      this.$refs.inputSearch.focus()
    },
    selectPage(page) {
      this.selectedPage = page
      this.getCampaignDetail()
    },
    goToAllCampaign() {
      this.$router.push({ name: 'advertiser' })
    },
    getCampaignDetail() {
      (async () => {
        this.loadingData = true
        let param = {}
        param.page = this.selectedPage
        if (this.searchText) {
          param.search = this.searchText
        }
        let response = await api.get(apiV2.campaignDetail(this.campaignId), {needToken: true, params: param})
        if (response.status == 200) {
          let data = response.data
          this.campaign = data
          this.maxPage = data.max_page
          this.loadingData = false
        } 
      })();
    },
    displayPeriod(start, end) {
      return `${lib.formatShortDate(start)} - ${lib.formatShortDate(end)}`
    },
    displayStatus(status) {
      return lib.displayCampaignStatus(status)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>